<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/app.component.ts.AppComponent.html